import { useWorkspaceStore } from '@/store/workspaceStore'
import { invalidateWorkspaceScopedQueries } from '@/services/workspaces/workspaceQueryKeys.js'

/** Switch workspace before opening a thread from another workspace. Preview does not call this. */
export function activateSearchThreadWorkspace(thread) {
  const activeId = useWorkspaceStore.getState().activeWorkspaceId
  if (!thread?.workspaceId || thread.workspaceId === activeId) return
  useWorkspaceStore.getState().setActiveWorkspaceId(thread.workspaceId)
  invalidateWorkspaceScopedQueries(thread.workspaceId)
}
